// GSAP Library
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// necessery to fire magic up
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

window.addEventListener('load', () => {
    //* module to move sections and elements inside these sections
    //* when section is in viewport

    //* it works for each bigger section on page or for smaller
    //* elements inside these sections

    // catching sections through whole page 
    const sectionToMoveup = document.querySelectorAll('[data-item="section"]');

    // checking if any section exists
    if (sectionToMoveup.length > 0  && window.matchMedia('screen and (min-width: 992px)').matches) {
        sectionToMoveup.forEach(section => {

            gsap.from(section, {
                scrollTrigger: section,
                y: 100,
                duration: 2,
                ease: 'power4.out',
                onStart: moveArticles,
            });

            // make an animation for each section

            // when animation started move smaller items(articles)
            function moveArticles() {
                //catching articles inside the section
                const article = section.querySelectorAll('[data-item="article"]');

                // make an animation for each article 
                // using stagger option it animates article one by one
                gsap.from(article, {
                    scrollTrigger: article,
                    duration: 2,
                    y: 200,
                    ease: 'power4.out',
                    stagger: {
                        from: 'start',
                        amount: .6
                    }
                });

                // or if there is only one article with overlay
                // move overlay to show text line by line
                setTimeout(function () {
                    const articleOverlay = document.querySelectorAll('[data-item="overlay"]');

                    if (articleOverlay) {
                        articleOverlay.forEach(article => {
                            article.classList.add('move-overlay');
                        });
                    }
                }, 1000);

            }
        });
    } else {
        sectionToMoveup.forEach(section => {

            gsap.from(section, {
                scrollTrigger: section,
                y: 0,
                duration: 2,
                ease: 'power4.out',
                onStart: moveArticles,
            });

            // make an animation for each section

            // when animation started move smaller items(articles)
            function moveArticles() {
                //catching articles inside the section
                const article = section.querySelectorAll('[data-item="article"]');

                // make an animation for each article 
                // using stagger option it animates article one by one
                gsap.from(article, {
                    scrollTrigger: article,
                    duration: 2,
                    y: 0,
                    ease: 'power4.out',
                    stagger: {
                        from: 'start',
                        amount: .6
                    }
                });

                // or if there is only one article with overlay
                // move overlay to show text line by line
                setTimeout(function () {
                    const articleOverlay = document.querySelectorAll('[data-item="overlay"]');

                    if (articleOverlay) {
                        articleOverlay.forEach(article => {
                            article.classList.add('move-overlay');
                        });
                    }
                }, 1000);

            }
        });
    }


    // catching right half of the section to move it to the center
    const sectionToMoveLeft = document.querySelectorAll('[data-item="section-right"]');

    // checking if any section exists
    if (sectionToMoveLeft.length > 0) {
        sectionToMoveLeft.forEach(section => {
            // move section from left to right
            gsap.from(section, {
                scrollTrigger: section,
                duration: 3,
                xPercent: 20,
                ease: 'power4.out'
            });

        });
    }

    // catching left half of the section to move it to the center
    const sectionToMoveRight = document.querySelectorAll('[data-item="section-left"]');

    // checking if any section exists
    if (sectionToMoveRight.length > 0) {
        sectionToMoveRight.forEach(section => {
            // move section from right to left when in viewport
            gsap.from(section, {
                scrollTrigger: {
                    trigger: section,
                    start: '50% bottom'
                },
                duration: 3,
                xPercent: -100,
                ease: 'power4.out'
            });

        });
    }


    //! MOVE FROM LEFT TO RIGHT
    // catching elements representing headers of sections or articles
    const elHeaderLeft = document.querySelectorAll('[data-item="article-el-header-left"]');

    // checking if any element exists
    if (elHeaderLeft.length > 0) {
        elHeaderLeft.forEach(el => {
            // move it to it's basic position (negative value moves element from left to right) 

            gsap.from(el, {
                scrollTrigger: el,
                duration: 2.5,
                xPercent: -100,
                ease: 'power4.out',
                onStart: removeCover
            });

            // an action to show paragraphs line by line
            // set timeout to make delay 
            // if it is not set the callback start
            // depends on the gsap options above
            function removeCover() {
                setTimeout(function () {
                    // catchiing paragraphs
                    const cover = document.querySelectorAll('[data-item="cover-left"]');
                    // const coverRect = cover.getBoundingClientRect();

                    // console.log(coverRect);
                    // console.log('ok');

                    // checking if any element exists
                    if (cover.length > 0) {
                        cover.forEach(cover => {
                            // add class that remove overlay
                            // details are set in css file
                            cover.classList.add('move-overlay');
                        });
                    }
                }, 800);
            }
        });
    }

    //! MOVE FROM RIGHT TO LEFT
    // catching elements representing headers of sections or articles
    const elHeaderRight = document.querySelectorAll('[data-item="article-el-header-right"]');

    // checking if any element exists
    if (elHeaderRight.length > 0) {
        elHeaderRight.forEach((el, i) => {
            // move it to it's basic position (negative value moves element from left to right) 

            if (i % 2 == 1) {
                gsap.from(el, {
                    scrollTrigger: el,
                    duration: 2.5,
                    xPercent: -100,
                    ease: 'power4.out',
                    onStart: removeCover,
                    onStartParams: [el]
                });
            } else {
                gsap.from(el, {
                    scrollTrigger: el,
                    duration: 2.5,
                    xPercent: 100,
                    ease: 'power4.out',
                    onStart: removeCover,
                    onStartParams: [el]
                });
            }

            // an action to show paragraphs line by line
            // set timeout to make delay 
            // if it is not set the callback start
            // depends on the gsap options above
            /*
             * show text
             * @param {HTMLElement} header  
             */
            function removeCover(header) {
                setTimeout(function () {
                    // catchiing paragraphs
                    const coverContainer = header.closest('[data-item="cover-container"]')

                    if (coverContainer) {
                        const cover = coverContainer.querySelector('[data-item="cover-right"]');

                        // checking if any element exists
                        if (cover) {
                            // add class that remove overlay
                            // details are set in css file
                            cover.classList.add('move-overlay');
                        }
                    }
                }, 800);
            }
        });
    }

    // catching icons in single row
    const elIcon = document.querySelectorAll('[data-item="article-el-icon"]');

    // move icons from left to right when in viewport
    gsap.from(elIcon, {
        scrollTrigger: elIcon,
        duration: 2.1,
        delay: .4,
        xPercent: -1000,
        ease: 'power4.out',
        stagger: {
            from: 'end',
            amount: .5
        }
    })


    ScrollTrigger.refresh(true);
});